import React, { useState , useRef } from "react";
import "./ComplaintsForm.css";
import { useTranslation } from "react-i18next";

export default function RegistrationForm() {
  const [submitting, setSubmitting] = useState(false);
  const { i18n } = useTranslation();
  const lang = i18n.language || "ta";

  // ===== STATES (ALL FIELDS) =====
  const [fullName, setFullName] = useState("");
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [relation, setRelation] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [voter, setVoter] = useState("");
  const [aadhaar, setAadhaar] = useState("");
  const [constituency, setConstituency] = useState("");
  const [photo, setPhoto] = useState(null);
  const fileInputRef = useRef(null);


  // ===== SUBMIT =====
const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);

  const formData = new FormData();

  formData.append("name", fullName);
  formData.append("dob", `${day}-${month}-${year}`);
  formData.append("age", age);
  formData.append("gender", gender);
  formData.append("relation", relation);
  formData.append("mobile", mobile);
  formData.append("email", email);
  formData.append("address", address);
  formData.append("city", city);
  formData.append("pincode", pincode);
  formData.append("voter", voter);
  formData.append("aadhaar", aadhaar);
  formData.append("constituency", constituency);
  formData.append("language", lang);

  // ✅ PHOTO FILE (IMPORTANT)
  if (photo) {
    formData.append("photo", photo);
  }

  try {
    await fetch("https://cmpranesh-admk.com/Mail/pdf-converter.php", {
      method: "POST",
      body: formData, // ❌ no headers
    });

    alert(lang === "en" ? "Submitted Successfully" : "வெற்றிகரமாக அனுப்பப்பட்டது");

    // RESET
    setFullName("");
    setDay("");
    setMonth("");
    setYear("");
    setAge("");
    setGender("");
    setRelation("");
    setMobile("");
    setEmail("");
    setAddress("");
    setCity("");
    setPincode("");
    setVoter("");
    setAadhaar("");
    setConstituency("");
    setPhoto(null);
   
if (fileInputRef.current) {
  fileInputRef.current.value = "";
}


  } catch (error) {
    console.error(error);
    alert(lang === "en" ? "Submission Failed" : "பதிவு தோல்வியடைந்தது");
  } finally {
    setSubmitting(false);
  }
};

  // ===== TEXTS =====
  const t = {
    name: { label: lang === "en" ? "Name *" : "பெயர் *", placeholder: lang === "en" ? "Enter the Name" : "பெயரை உள்ளிடவும்" },
    dob: lang === "en" ? "Date of Birth" : "பிறந்த தேதி",
    day: lang === "en" ? "Day" : "நாள்",
    month: lang === "en" ? "Month" : "மாதம்",
    year: lang === "en" ? "Year" : "ஆண்டு",
    age: lang === "en" ? "Age" : "வயது",
    gender: {
      label: lang === "en" ? "Gender" : "பாலினம்",
      male: lang === "en" ? "Male" : "ஆண்",
      female: lang === "en" ? "Female" : "பெண்",
      trans: lang === "en" ? "Transgender" : "திருநங்கை",
    },
    relation: { label: lang === "en" ? "Father / Mother / Husband Name *" : "தந்தை / தாய் / கணவர் பெயர் *", placeholder: lang === "en" ? "Enter Name" : "பெயரை உள்ளிடவும்" },
    mobile: { label: lang === "en" ? "Mobile No. *" : "அலைப்பேசி எண் *", placeholder: lang === "en" ? "Enter Mobile" : "மொபைல் எண்" },
    email: { label: lang === "en" ? "Email" : "மின்னஞ்சல்", placeholder: lang === "en" ? "Enter Email" : "மின்னஞ்சல்" },
    address: { label: lang === "en" ? "Address" : "முகவரி", placeholder: lang === "en" ? "Enter Address" : "முகவரி" },
    city: { label: lang === "en" ? "City" : "நகரம்", placeholder: lang === "en" ? "Enter City" : "நகரம்" },
    pincode: { label: lang === "en" ? "Pincode *" : "அஞ்சல் எண் *", placeholder: lang === "en" ? "Enter Pincode" : "அஞ்சல் எண்" },
    voter: { label: lang === "en" ? "Voter ID No *" : "வாக்காளர் எண் *", placeholder: lang === "en" ? "Enter Voter ID" : "வாக்காளர் எண்" },
    aadhaar: { label: lang === "en" ? "Aadhaar No *" : "ஆதார் எண் *", placeholder: lang === "en" ? "Enter Aadhaar" : "ஆதார் எண்" },
    constituency: { label: lang === "en" ? "Constituency *" : "தொகுதி பெயர் *", placeholder: lang === "en" ? "Enter Constituency" : "தொகுதி" },
    submit: lang === "en" ? "Register" : "பதிவு செய்யவும்",
  };

  return (
    <div className="regForm-container">
      <form className="regForm" onSubmit={handleSubmit}>

        {/* Name */}
        <div className="regForm-row">
          <label className="regForm-label">{t.name.label}</label>
          <input className="regForm-input" value={fullName} onChange={e => setFullName(e.target.value)} placeholder={t.name.placeholder} required/>
        </div>

        {/* DOB */}
        <div className="regForm-row">
          <label className="regForm-label">{t.dob}</label>
          <div className="regForm-dob">
            <select className="regForm-select" value={day} onChange={e => setDay(e.target.value)}>
              <option value="">{t.day}</option>
              {Array.from({ length: 31 }, (_, i) => <option key={i+1}>{i+1}</option>)}
            </select>

            <select className="regForm-select" value={month} onChange={e => setMonth(e.target.value)}>
              <option value="">{t.month}</option>
              {Array.from({ length: 12 }, (_, i) => <option key={i+1}>{i+1}</option>)}
            </select>

            <select className="regForm-select" value={year} onChange={e => setYear(e.target.value)}>
              <option value="">{t.year}</option>
              {Array.from({ length: new Date().getFullYear() - 1950 + 1 }, (_, i) => <option key={i}>{1950 + i}</option>)}
            </select>
          </div>
        </div>

        {/* Age */}
        <div className="regForm-row">
          <label className="regForm-label">{t.age}</label>
          <input className="regForm-input" value={age} onChange={e => setAge(e.target.value)} required/>
        </div>

        {/* Gender */}
        <div className="regForm-row">
          <label className="regForm-label">{t.gender.label}</label>
          <div className="regForm-radioGroup">
            <label><input type="radio" value="Male" checked={gender==="Male"} onChange={e=>setGender(e.target.value)} /> {t.gender.male}</label>
            <label><input type="radio" value="Female" checked={gender==="Female"} onChange={e=>setGender(e.target.value)} /> {t.gender.female}</label>
            <label><input type="radio" value="Transgender" checked={gender==="Transgender"} onChange={e=>setGender(e.target.value)} /> {t.gender.trans}</label>
          </div>
        </div>

        {/* Relation */}
        <div className="regForm-row">
          <label className="regForm-label">{t.relation.label}</label>
          <input className="regForm-input" value={relation} onChange={e=>setRelation(e.target.value)} placeholder={t.relation.placeholder} required/>
        </div>

        {/* Mobile */}
        <div className="regForm-row">
          <label className="regForm-label">{t.mobile.label}</label>
          <input className="regForm-input" value={mobile} onChange={e=>setMobile(e.target.value)} placeholder={t.mobile.placeholder} required/>
        </div>

        {/* Email */}
        <div className="regForm-row">
          <label className="regForm-label">{t.email.label}</label>
          <input className="regForm-input" value={email} onChange={e=>setEmail(e.target.value)} placeholder={t.email.placeholder} required/>
        </div>

        {/* Address */}
        <div className="regForm-row">
          <label className="regForm-label">{t.address.label}</label>
          <input className="regForm-input" value={address} onChange={e=>setAddress(e.target.value)} placeholder={t.address.placeholder} required/>
        </div>

        {/* City */}
        <div className="regForm-row">
          <label className="regForm-label">{t.city.label}</label>
          <input className="regForm-input" value={city} onChange={e=>setCity(e.target.value)} placeholder={t.city.placeholder} required />
        </div>

        {/* Pincode */}
        <div className="regForm-row">
          <label className="regForm-label">{t.pincode.label}</label>
          <input className="regForm-input" value={pincode} onChange={e=>setPincode(e.target.value)} placeholder={t.pincode.placeholder} required/>
        </div>

        {/* Voter */}
        <div className="regForm-row">
          <label className="regForm-label">{t.voter.label}</label>
          <input className="regForm-input" value={voter} onChange={e=>setVoter(e.target.value)} placeholder={t.voter.placeholder} required />
        </div>

        {/* Aadhaar */}
        <div className="regForm-row">
          <label className="regForm-label">{t.aadhaar.label}</label>
          <input className="regForm-input" value={aadhaar} onChange={e=>setAadhaar(e.target.value)} placeholder={t.aadhaar.placeholder} required/>
        </div>

        {/* Constituency */}
        <div className="regForm-row">
          <label className="regForm-label">{t.constituency.label}</label>
          <input className="regForm-input" value={constituency} onChange={e=>setConstituency(e.target.value)} placeholder={t.constituency.placeholder} required />
        </div>

        {/* Photo Upload */}
<div className="regForm-row">
  <label className="regForm-label">
    {lang === "en" ? "Passport Size Photo *" : "பாஸ்போர்ட் அளவு புகைப்படம் *"}
  </label>

  <input
  type="file"
  accept="image/*"
  className="regForm-input"
  ref={fileInputRef}
  onChange={(e) => setPhoto(e.target.files[0])}
  required
/>
</div>
        {/* Submit */}
        <div className="regForm-row">
  <center>
    <button
      type="submit"
      className="regForm-submitBtn"
      disabled={submitting}
    >
      {submitting
        ? lang === "en"
          ? "Registering..."
          : "பதிவு செய்யப்படுகிறது"
        : t.submit}
    </button>
  </center>
</div>


      </form>
    </div>
  );
}
